//include 26
jQuery(function(){
//*
    $('.tabs-container').on('change.zf.tabs', function (event, tab) {
    	/*
    	var tabContentSelector = tab.find("a").attr("href");
    	if(!!tabContentSelector){
    		$(tabContentSelector).foundation();
    	}
    	//*/
    	Foundation.reInit('equalizer');
	});
//*/
});